// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3S5cw","error":"Textarea_error__285dR","readonly":"Textarea_readonly__39kX3","disabled":"Textarea_disabled__212X1"};